import Vue from "vue";
Vue.use(require('vue-cookies'));
const Helper = {
    key: {
        callback_url : "callbackUrl",
        shareUser: "shareUser"
    },
    userType: {
        private: 3,
        business: 4,
        privateAndBusiness: 5
    },
    getAppLang: () => {
        const lang = Vue.$cookies.get('language');
        if (lang) {
            return lang
        } else {
            return 'he'
        }
    },
    setAppLang: (lang) => {
        Vue.$cookies.set('language', lang, '30d');
    },
    // saveCookies : (key, value) => {
    //     const { cookies } = useCookies();
    //     cookies.set(key, value)
    // },
    // getCookies : (key, dfValue) => {
    //     const { cookies } = useCookies();
    //     if (cookies.isKey(key)) {
    //         return cookies.get(key)
    //     } else {
    //         return dfValue
    //     }
    // },
    // hasCookies : (key) => {
    //     const { cookies } = useCookies();
    //     return cookies.isKey(key)

    // },
    decodeBase64String: (base64Str) => {
        const rs= decodeURIComponent(escape(window.atob(base64Str)));
        return rs;
    },
    // getUserToken : () => {
    //     const { cookies } = useCookies();
    //     if (cookies.isKey('user')) {
    //         return cookies.get('user').token
    //     } else {
    //         return ""
    //     }
    // },
    // getUser : () => {
    //     const { cookies } = useCookies();
    //     if (cookies.isKey('user')) {
    //         return cookies.get('user')
    //     } else {
    //         return {}
    //     }
    // },
    // logout : () => {
    //     const { cookies } = useCookies();
    //     cookies.remove("user")
    // },
    showMessage: (message) => {
        var loadingBox = document.getElementById("g-box")
        var loadingBoxMsg= document.getElementById("g-box-msg")
        loadingBoxMsg.innerHTML = message;
        loadingBox.style.display = "flex";
    },
    hideMessage: () => {
        var loadingBox = document.getElementById("g-box")
        loadingBox.style.display = "none";       
    }
}

export default Helper;